<template>
    <v-container>
        <v-row>
            <v-col cols="12" md="3">
                <v-select
                    v-model="selectedEvent"
                    :items="events"
                    item-text="name"
                    item-value="id"
                    :disabled="isLoading"
                    label="Event"
                    outlined
                    dense
                    hide-details
                ></v-select>
            </v-col>
        </v-row>
        <div class="my-3 font-weight-bold text-h6">Encounter Documents</div>
        <v-row>
            <v-col cols="12" md="3">
                <v-select
                    v-model="selectedTeamOption"
                    :items="teamOptions"
                    :disabled="!selectedEvent"
                    label="Which Encounters?"
                    outlined
                    color="primary"
                    dense
                    hide-details
                ></v-select>
            </v-col>
            <v-col cols="12" md="2">
                <v-checkbox v-model="includeUnapproved" label="Include Unapproved?" class="mt-1"></v-checkbox>
            </v-col>
            <v-col cols="12" md="2" v-if="canReadShares">
                <v-checkbox v-model="includeShared" label="Include Shared?" class="mt-1"></v-checkbox>
            </v-col>
            <v-col>
                <v-btn @click="getEncounters" :disabled="!selectedEvent || isLoading">Download Encounters</v-btn>
            </v-col>
        </v-row>
        <template v-if="canReadAll">
            <div class="my-3 font-weight-bold text-h6">Timetable</div>
            <v-row>
                <v-col>
                    <v-btn @click="getTimeTable" color="primary" :disabled="!selectedEvent || isLoading">
                        Download Timetable
                    </v-btn>
                </v-col>
            </v-row>
        </template>
        <template v-if="canReadAll">
            <div class="my-3 font-weight-bold text-h6">Makeup Report</div>
            <v-row>
                <v-col>
                    <v-btn @click="getMakeupReport" color="primary" :disabled="!selectedEvent || isLoading">
                        Download Costume and Makeup Report
                    </v-btn>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>
<script>
import api from '@/api'
import { mapState, mapGetters } from 'vuex'
import permissionsSet from '@/components/permissions'
const encounter = 'encounter'
export default {
    name: 'EncounterPrint',
    data() {
        return {
            isLoading: false,
            selectedEvent: 0,
            encounters: [],
            includeUnapproved: false,
            includeShared: false,
            selectedTeamOption: null,
        }
    },
    computed: {
        ...mapState(['user']),
        ...mapGetters(['events', 'nextEvent', 'currentEvent', 'userTeams']),
        userDefaultTeamId() {
            if (this.user && this.user.defaultTeam) {
                let teamId = parseInt(this.user.defaultTeam)
                if (!isNaN(teamId)) return teamId
            }
            return -1
        },
        event() {
            if (!this.selectedEvent || !this.events || this.events.length === 0) return
            let event = this.events.find(x => x.id === this.selectedEvent)
            return event
        },
        teamOptions() {
            let options = []
            if (this.canReadAll) {
                options.push({ text: 'All', value: null })
            }
            options.push({ text: 'My Team(s) only', value: 0 })
            let userTeams = this.availableTeams
            if (userTeams.length > 1) {
                this.availableTeams.forEach(x => {
                    options.push({ text: x.name, value: x.id })
                })
            }
            return options
        },
        availableTeams() {
            return this.userTeams(encounter)
        },
        canReadShares() {
            if (this.user && this.user[encounter]) {
                return (
                    this.user[encounter].all.includes(permissionsSet.Read) ||
                    (this.user.teams.includes(this.doc.teamId) && this.userPermissions.includes(permissionsSet.Edit))
                )
            } else {
                return false
            }
        },
        canReadAll() {
            if (this.user && this.user[encounter]) {
                return this.user[encounter].all.includes(permissionsSet.Read)
            } else {
                return false
            }
        },
    },
    mounted() {
        if (this.currentEvent) {
            this.selectedEvent = this.currentEvent
        }
    },
    methods: {
        getEncounters() {
            if (this.selectedEvent === 0) return
            this.isLoading = true
            this.encounters = []
            var query = ''
            if (this.selectedTeamOption === 0) {
                let teams = this.availableTeams.map(x => x.id)
                var teamsString = teams.join('&teamIds=')
                query = `${query}teamIds=${teamsString}`
            } else if (this.selectedTeamOption !== null) {
                query = `${query}teamIds=${this.selectedTeamOption}`
            }
            if (this.includeUnapproved) {
                query = `${query}&includeUnapproved=true`
            }
            if (this.includeShared) {
                query = `${query}&includeShared=true`
            }
            api.client
                .get(`/encounters/print/${this.selectedEvent}${query ? `?${query}` : ``}`, {
                    responseType: 'blob',
                })
                .then(res => {
                    const blob = new Blob([res.data], { type: res.data.type })
                    let contentDisposition = res.headers['content-disposition']
                    let match = contentDisposition.match(/filename\s*=\s*"?(.+)"?;/i)
                    let filename = match[1]
                    console.log(filename)
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = filename
                    document.body.appendChild(link)
                    link.click()
                    link.remove()
                })
                .finally(() => (this.isLoading = false))
        },
        getTimeTable() {
            api.client
                .get(`/encounters/timetable/${this.selectedEvent}`, {
                    responseType: 'blob',
                })
                .then(res => {
                    const blob = new Blob([res.data], { type: res.data.type })
                    let contentDisposition = res.headers['content-disposition']
                    let match = contentDisposition.match(/filename\s*=\s*"?(.+)"?;/i)
                    let filename = match[1]
                    console.log(filename)
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = filename
                    document.body.appendChild(link)
                    link.click()
                    link.remove()
                })
        },
        getMakeupReport() {
            api.client
                .get(`/encounters/print/makeup/${this.selectedEvent}`, {
                    responseType: 'blob',
                })
                .then(res => {
                    const blob = new Blob([res.data], { type: res.data.type })
                    let contentDisposition = res.headers['content-disposition']
                    let match = contentDisposition.match(/filename\s*=\s*"?(.+)"?;/i)
                    let filename = match[1]
                    console.log(filename)
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = filename
                    document.body.appendChild(link)
                    link.click()
                    link.remove()
                })
        },
        eventChange() {
            this.$store.commit('setCurrentEvent', this.selectedEvent)
        },
    },
}
</script>
<style>
.reportPrintNormal {
    border-style: none;
    font-family: 'Courier New', sans-serif;
    font-size: 10pt;
    vertical-align: top;
}

.tdLeftTop {
    margin: 0px 0px 0px 0px;
    padding-right: 10px;
    text-align: left;
    vertical-align: top;
}
</style>
